import { invoke, isTauri } from '@tauri-apps/api/core'
import {
  isPermissionGranted,
  requestPermission,
  sendNotification,
} from '@tauri-apps/plugin-notification'
import { platform } from '@tauri-apps/plugin-os'

export const NOTIFICATION_GOTO_EVENT = 'wallet-tracker://goto-url'

export type ShowNotificationOptions = {
  title: string
  description: string
  buttonLabel?: string
  actionUrl?: string
  sound?: string
  imageUrl?: string
}

const checkPermission = async (): ReturnType<typeof requestPermission> => {
  const granted = await isPermissionGranted()
  if (granted) {
    return 'granted'
  }
  return requestPermission()
}

export const showNotification = async (
  options: ShowNotificationOptions,
): Promise<void> => {
  try {
    if (!isTauri()) {
      return
    }

    const permission = await checkPermission()
    if (permission !== 'granted') {
      return
    }

    let currentPlatform: string
    try {
      currentPlatform = platform()
    } catch {
      currentPlatform = 'unknown'
    }

    if (
      (currentPlatform === 'windows' || currentPlatform === 'macos') &&
      options.actionUrl
    ) {
      try {
        await invoke('show_notification', {
          title: options.title,
          description: options.description,
          buttonLabel: options.buttonLabel ?? undefined,
          actionUrl: options.actionUrl,
          sound: options.sound ?? undefined,
          imageUrl: options.imageUrl ?? undefined,
        })
        return
      } catch {
        // Fall through to Tauri plugin
      }
    }

    sendNotification({
      title: options.title,
      body: options.description,
    })
  } catch {
    // Ignore errors
  }
}

export type TauriNotificationOptions = Parameters<typeof sendNotification>[0]

export const sendTauriNotification = async (
  options: TauriNotificationOptions,
) => {
  if (!isTauri()) {
    return
  }
  const permission = await checkPermission()
  if (permission !== 'granted') {
    return
  }
  sendNotification(options)
}
